import { getItems, getMidaImatge } from '@portal-internet/core';
import { getData } from '@portal-internet/bff';
import Destacat from 'components/3cat/Destacat';
import __isEmpty from 'lodash/isEmpty';
import { useQuery } from 'react-query';
import SliderWrapper from '../SliderWrapper';

const getCanalObject = (codi_canal) => {
    return [{ desc: 'Esport3', id: 'PUC_E3', main: true }];
};

export default function SuperdestacatTematic(props) {
    const { nom, format, has_link, tipus, titolFirstTira, titolLogo, prefetchedData, id, urlDadesByProducte, field, tema } =
        props;
    const initialData = prefetchedData?.[id] ? prefetchedData?.[id] : null;
    const { data } = useQuery([field, { url: urlDadesByProducte }], getData, {
        initialData: initialData,
        staleTime: Infinity,
        refetchOnMount: !initialData ? 'always' : false
    });
    let items = getItems(data);
    const isDirecte = tipus === 'DIRECTES';
    if (isDirecte) {
        items = items?.filter((item) => item.ara_fem);
    }
    let itemSuperdestacat = !__isEmpty(items) ? JSON.parse(JSON.stringify(items[0])) : false; // ens quedem el primer element fent una copia de l'item
    const itemSlider = items?.slice(1);

    if (!__isEmpty(isDirecte ? itemSuperdestacat?.ara_fem : itemSuperdestacat)) {
        itemSuperdestacat = isDirecte ? itemSuperdestacat.ara_fem : itemSuperdestacat;
        const titol = itemSuperdestacat.titol || itemSuperdestacat.titol_programa;
        const titolPromo = itemSuperdestacat?.titol_promo;
        const agrupacions = itemSuperdestacat?.agrupacions;
        const codiEspectador = itemSuperdestacat.codis_etics || itemSuperdestacat.codi_etic;
        const tipologiaRelacionada = itemSuperdestacat.programes?.[0]?.nom || itemSuperdestacat.programes?.programa?.[0]?.nom;
        const idRelacionat = itemSuperdestacat.programes?.[0]?.id || itemSuperdestacat.programes?.programa?.[0]?.id;
        const nomprograma = itemSuperdestacat.programes?.[0]?.nom_bonic || itemSuperdestacat.programes?.programa?.[0]?.nom_bonic;
        const entradeta = itemSuperdestacat.entradeta || itemSuperdestacat.destacat_text;
        const entradetaPromo = itemSuperdestacat?.entradeta_promo;
        const canals = isDirecte ? getCanalObject(itemSuperdestacat.codi_canal) : itemSuperdestacat.canals;
        const etiqueta = itemSuperdestacat.etiquetes?.find((et) => et.main === true)?.desc;
        const callToAction = itemSuperdestacat.call_to_action;
        const link = callToAction ? itemSuperdestacat.url : null;
        const iconaBoto = callToAction ? false : null;
        const formats = itemSuperdestacat?.formats;
        const infoDistribucio = itemSuperdestacat?.info_distribucio;
        return (
            <>
                <Destacat
                    supertitol={titolFirstTira}
                    titolLogo={titolLogo}
                    titol={titol}
                    titolPromo={titolPromo}
                    titolPrograma={
                        itemSuperdestacat?.programes_tv?.[0]?.titol ||
                        itemSuperdestacat?.programes_radio?.[0]?.titol ||
                        itemSuperdestacat?.programes_tv?.[0]?.desc ||
                        itemSuperdestacat?.programes_radio?.[0]?.desc ||
                        itemSuperdestacat?.titol_programa
                    }
                    imatges={itemSuperdestacat.imatges}
                    imatgesPrograma={
                        itemSuperdestacat?.programes_tv?.[0]?.imatges || itemSuperdestacat?.programes_radio?.[0]?.imatges
                    }
                    entradeta={entradeta}
                    entradetaPromo={entradetaPromo}
                    canals={canals}
                    tipologia={isDirecte ? 'DIRECTES_ARAFEM' : itemSuperdestacat.tipologia}
                    link={link}
                    linkId={isDirecte ? itemSuperdestacat.codi_canal : itemSuperdestacat.id}
                    tipologiaRelacionada={tipologiaRelacionada}
                    idRelacionat={idRelacionat}
                    slugPrograma={nomprograma}
                    durada={itemSuperdestacat.durada}
                    codiEspectador={codiEspectador}
                    tipus={isDirecte ? 'DIRECTES' : 'SUPERDESTACATTEMATIC'}
                    callToAction={callToAction}
                    iconaBoto={iconaBoto}
                    nombonic={itemSuperdestacat.nombonic}
                    tema={tema}
                    agrupacions={agrupacions}
                    etiqueta={etiqueta}
                    formats={formats}
                    infoDistribucio={infoDistribucio}
                    dataTestId='superdestacat'
                />
                {!__isEmpty(itemSlider) && (
                    <SliderWrapper
                        has_link={has_link}
                        titol={nom}
                        items={itemSlider}
                        midaImatge={getMidaImatge(format)}
                        format={format}
                        tipus={tipus}
                        urlDadesByProducte={urlDadesByProducte}
                    />
                )}
            </>
        );
    } else return null;
}
